(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function initRecommendationsSlider() {
    var el = document.querySelector('#recommendations-swiper');
    if (!el || typeof Swiper === 'undefined') return;

    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {}
    }

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 15,
      speed: 600,
      threshold: 15,
      loop: false,
      slideToClickedSlide: false,
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      noSwipingSelector: '.rec-quickadd-toggle, .rec-options, .rec-options *',
      breakpoints: { 768: { 
        spaceBetween: 24,
        slidesPerView: 5,
      } },
    });
  }

  var loadProductRecommendationsIntoSection = function () {
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (!productRecommendationsSection) return;

    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var sectionId = productRecommendationsSection.dataset.sectionId;
    var intent = productRecommendationsSection.dataset.intent || 'related';
    var requestUrl = new URL(productRecommendationsSection.dataset.url, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    requestUrl.searchParams.set('limit', limit);
    requestUrl.searchParams.set('product_id', productId);
    requestUrl.searchParams.set('intent', intent);

    var request = new XMLHttpRequest();
    request.open('GET', requestUrl.toString());

    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;

        var newRec = container.querySelector('.product-recommendations');
        if (newRec) {
          productRecommendationsSection.innerHTML = newRec.innerHTML;
          setTimeout(initRecommendationsSlider, 0);
        }
      }
    };

    request.send();
  };

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event.detail.sectionId === 'category-recommendations-slider' ||
      event.detail.sectionId === 'product-recommendations'
    ) {
      loadProductRecommendationsIntoSection();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    loadProductRecommendationsIntoSection();
    setTimeout(initRecommendationsSlider, 0);
  });

  } catch(e) { console.error(e); }
})();
})();
